import { DEFAULT_TRADING_LAYOUT_SPEC } from '@src/components/AppLayout/Layouts/Trading/DefaultTradingLayoutSpec';
import type { SerializedDockview } from 'dockview';
import { v1 as uuid } from 'uuid';
import { DEFAULT_GRID, WATCHLIST_PANELS } from '../../components/AppLayout/Layouts/Trading/DefaultTrading';
import { BLOTTER_PANELS } from '../../components/AppLayout/Layouts/Trading/shared';
import type { LayoutSpec, TypedGroupviewPanelConfigState } from '../../types/LayoutConfig';
import type { MarketTab } from '../MarketTabs.types';
import { mapTabToPanel } from './mapTabToPanel';

export const convertMarketTabsToDockviewLayout = (marketTabs: MarketTab[]): LayoutSpec => {
  const tabsWithIds = marketTabs.map(tab => ({
    ...tab,
    id: tab.id ?? uuid(),
  }));

  const dockViewLayout: SerializedDockview = {
    grid: structuredClone<SerializedDockview['grid']>(DEFAULT_GRID),
    panels: {
      ...structuredClone(WATCHLIST_PANELS),
      ...structuredClone(BLOTTER_PANELS),
      ...tabsWithIds.reduce((acc: Record<string, TypedGroupviewPanelConfigState>, tab) => {
        acc[tab.id] = mapTabToPanel(tab);
        return acc;
      }, {}),
    },
  };
  if (
    Array.isArray(dockViewLayout.grid.root.data) &&
    Array.isArray(dockViewLayout.grid.root.data[0].data) &&
    !Array.isArray(dockViewLayout.grid.root.data[0].data[1].data)
  ) {
    dockViewLayout.grid.root.data[0].data[1].data.views = tabsWithIds.map(tab => tab.id);
  }

  return {
    ...DEFAULT_TRADING_LAYOUT_SPEC,
    dockViewLayout,
  };
};
